import React from 'react';
import { DifficultyOption } from '../../types';

interface DifficultySelectionProps {
  difficultyOptions: DifficultyOption[];
  selectedDifficulty: string;
  onDifficultyChange: (difficulty: string) => void;
}

const DifficultySelection: React.FC<DifficultySelectionProps> = ({
  difficultyOptions,
  selectedDifficulty,
  onDifficultyChange
}) => {
  return (
    <div className="mb-4">
      <label className="form-label fw-semibold">
        <i className="fas fa-chart-bar me-2 text-primary"></i>
        Difficulty Level <span className="text-danger">*</span>
      </label>
      <div className="row g-2">
        {difficultyOptions.map(difficulty => (
          <div key={difficulty.value} className="col-md-4">
            <input
              type="radio"
              className="btn-check"
              name="difficulty"
              id={difficulty.value}
              checked={selectedDifficulty === difficulty.value}
              onChange={() => onDifficultyChange(difficulty.value)}
            />
            <label 
              className="btn btn-outline-secondary w-100 py-2"
              htmlFor={difficulty.value}
              style={{ 
                borderRadius: '12px',
                borderColor: difficulty.color + '40'
              }}
            >
              <i className="fas fa-circle me-2" style={{ color: difficulty.color }}></i>
              {difficulty.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DifficultySelection;